import {memo} from "react";
import {CELL_SIZE} from "../../utility/types";
import {Camera} from "../../utility/camera";

type SwimlaneProps = {
  label: string;
  color: string;
  minX: number; // Left edge in cells
  maxX: number; // Right edge in cells
  camera: Camera;
};

export const Swimlane = memo(({label, color, minX, maxX, camera}: SwimlaneProps) => {
  const minPixel = minX * CELL_SIZE;
  const width = (maxX - minX) * CELL_SIZE;

  // Extend far beyond visible area to span full diagram height
  const topY = -10000;
  const height = 20000;

  // Calculate label position to keep it at the top of the visible viewport
  // Camera.position is the center of the viewport in world space
  // We want the label at the top of the viewport + some padding
  const viewportHeightInWorldSpace = camera.size.y / camera.zoomFactor;
  const topOfViewport = camera.position.y - viewportHeightInWorldSpace / 2;
  const labelY = topOfViewport + 64; // 64px padding from top in world space
  const labelYRelativeToSwimlane = labelY - topY;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        transform: `translate(${minPixel}px, ${topY}px)`,
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: `${color}10`,
        borderLeft: `2px solid ${color}4D`,
        borderRight: `2px solid ${color}4D`,
        pointerEvents: "none",
      }}
    >
      {/* Label positioned at top of visible viewport */}
      <div
        style={{
          position: "absolute",
          top: `${labelYRelativeToSwimlane}px`,
          left: "50%",
          transform: "translate(-50%, 0)",
          backgroundColor: "white",
          padding: "8px 16px",
          borderRadius: "12px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          fontSize: "14px",
          fontWeight: 600,
          color: color,
        }}
      >
        {label}
      </div>
    </div>
  );
});
